import {Component, Input, OnInit} from '@angular/core';
import {DynamicDialogConfig, DynamicDialogRef} from "primeng/dynamicdialog";
import {ListaItem} from "../../../../_models/lista-item";
import {TasasVariablesCondiciones} from "../../../../_models/tasas-variables-condiciones";
import moment from 'moment-timezone';
import {AutenticacionService} from "../../../../_services/autenticacion.service";
import {TasasVariablesCondicionesService} from "../../../../_services/tasas-variables-condiciones.service";
import {NavService} from "../../../../_services/_nav.service";
import {
  TasasVariablesCondicionesNotificacionesService
} from "../../../../_services/tasas-variables-condiciones-notificaciones.service";
import {EstadosTasasVariables} from "../../../../_enums/enum";

@Component({
  selector: 'app-aprobacion-tasa',
  templateUrl: './aprobacion-tasa.component.html',
  styleUrls: ['./aprobacion-tasa.component.css']
})
export class AprobacionTasaComponent implements OnInit {

  @Input() registro: any;
  @Input() lisEstados: ListaItem[];
  @Input() lisRegistros: TasasVariablesCondiciones[];
  observacion = '';
  inactivarRegistro: TasasVariablesCondiciones;
  guardando = false;
  constructor(private config: DynamicDialogConfig,
              private authService: AutenticacionService,
              private ref: DynamicDialogRef,
              private navService: NavService,
              private notificar: TasasVariablesCondicionesNotificacionesService,
              private tasasVariablesCondicionesService: TasasVariablesCondicionesService) { }

  ngOnInit() {
    this.registro = this.config.data.registro;
    this.lisEstados = this.config.data.lisEstados;
    this.lisRegistros = this.config.data.lisRegistros;
  }

  salir(decision: string = null){
    this.guardando = true;
    if (decision === 'APROBAR') {
      const registroInicio = new Date(this.registro.fechaInicioVigencia + 'T00:00:00');
      const hoy = new Date(moment(new Date()).format('YYYY-MM-DD') + 'T00:00:00');
      if (registroInicio.getTime() > hoy.getTime()) {
        this.registro.idEstadoFuncionalidad = this.lisEstados.find(x => x.codigo === EstadosTasasVariables.CNFAPR).idLista;
      }
      if (registroInicio.getTime() === hoy.getTime()) {
        this.registro.idEstadoFuncionalidad = this.lisEstados.find(x => x.codigo === EstadosTasasVariables.CNFACT).idLista;
        const buscar = this.lisRegistros.find(x => x.codigoEstado === EstadosTasasVariables.CNFACT);
        if (!!buscar) {
          this.inactivarRegistro = buscar;
          this.inactivarRegistro.idEstadoFuncionalidad = this.lisEstados.find(x => x.codigo === EstadosTasasVariables.CNFINA).idLista;
          this.inactivarRegistro.idUsuarioAprueba = this.authService.obtenerIdUsuarioLogueado();
          this.inactivarRegistro.fechaAprobacion = moment().tz('America/Bogota').format('YYYY-MM-DDTHH:mm:ss');
        }
      }
    }
    if (decision === 'DENEGAR') {
      this.registro.idEstadoFuncionalidad = this.lisEstados.find(x => x.codigo === EstadosTasasVariables.CNFDEN).idLista;
    }
    this.registro.observacion = this.observacion;
    this.registro.idUsuarioAprueba = this.authService.obtenerIdUsuarioLogueado();
    this.registro.fechaAprobacion = moment().tz('America/Bogota').format('YYYY-MM-DDTHH:mm:ss');

    const lisBulk: any[] = [];
    lisBulk.push(this.registro);
    if (this.inactivarRegistro) {
      lisBulk.push(this.inactivarRegistro);
    }
    this.tasasVariablesCondicionesService.bulk(lisBulk).subscribe(res => {
      this.guardando = false;
      this.navService.setMesage( 0, {
        severity: 'success', summary: this.navService.buscarMensaje( 'LBL_INFORMACION' ),
        detail: this.navService.buscarMensaje( 'TASASVARIABLES.MSG_REGACTU' )
      } );

      const listaIds = [];
      lisBulk.map(e => {
        listaIds.push(e.idTasaVariableCondicion);
      });
      const objeto = {ids: listaIds, codigoNotificacion: 'NOTAPRTAS'};
      this.notificar.crear(objeto).subscribe(res => {});


      this.ref.close( decision );
    }, error => {
      this.guardando = false;
      this.navService.setMesage(0, {
        severity: 'error', summary: this.navService.buscarMensaje('LBL_INFORMACION'),
        detail: this.navService.buscarMensaje('FABRICACREDITO.LBL_HAOCURRIDOERROR')
      });
    });
  }

}
